import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import PremiumIconFilled from '../../../assets/icons/PremiumIconFilled';
import theme from '../../../assets/theme';
import { useMetrics } from '../../../hooks/useMetrics';
import usePaywallPrompt from '../../../hooks/usePaywallPrompt';
import { IconWrapper } from '../../_atoms/IconWrapper';

const PlanIndicator = ({ isMobileDrawer }: { isMobileDrawer: boolean }) => {
  const {
    isReady,
    promptPaywall,
    paywallComponent,
    plan,
    isFreemium,
    isPremium,
    isEnterprise,
    tenantName,
  } = usePaywallPrompt({
    startState: { screen: 'chooseProduct' },
  });
  const metrics = useMetrics();
  const { t } = useTranslation('Host');

  const handleShowPaywall = () => {
    if (isReady) {
      metrics.logEvent('Upgrade.Clicked', {
        location: isMobileDrawer ? 'mobileHamburgerMenu' : 'sidebar',
      });
      promptPaywall();
    }
  };

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      {paywallComponent}
      <div>
        <span style={{ fontSize: 16 }}>{isFreemium ? 'Personal' : tenantName}</span>
      </div>
      <PointedRow $isMobileDrawer={isMobileDrawer}>
        {isReady && (
          <>
            <span style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{plan}</span>
            <div
              style={{
                height: 3,
                width: 3,
                background: theme.colors.greyDark,
                borderRadius: 20,
              }}
            ></div>
            {isFreemium && (
              <>
                <span
                  style={{
                    fontWeight: 'bold',
                    lineHeight: '14px',
                    fontSize: 12,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  onClick={handleShowPaywall}
                >
                  {t('Upgrade')}
                </span>
                <IconWrapper height="10px" width="10px" color={theme.colors.yellow}>
                  <PremiumIconFilled />
                </IconWrapper>
              </>
            )}
            {(isPremium || isEnterprise) && (
              <span style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                {t('Unlimited lessons')}
              </span>
            )}
          </>
        )}
      </PointedRow>
    </div>
  );
};

export default PlanIndicator;

const PointedRow = styled.div<{ $isMobileDrawer: boolean }>`
  display: flex;
  align-items: center;
  gap: 3px;
  height: 20px;

  ${({ $isMobileDrawer }) =>
    $isMobileDrawer
      ? css`
          color: ${theme.colors.white};
        `
      : css`
          color: ${theme.colors.greyDark};
        `}
`;
